const topics = [
  { label: '高清电影', icon: 'ri-movie-line' },
  { label: '热门综艺', icon: 'ri-tv-line' },
  { label: '纪录大片', icon: 'ri-film-line' },
  { label: '创意短片', icon: 'ri-clapperboard-line' },
  { label: '经典回顾', icon: 'ri-history-line' },
  { label: '每日更新', icon: 'ri-calendar-check-line' },
  { label: '影视解说', icon: 'ri-mic-line' },
  { label: '精彩集锦', icon: 'ri-flashlight-line' },
  { label: '独家推荐', icon: 'ri-star-line' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100/80 text-primary-700 text-xs font-label font-semibold mb-4 whitespace-nowrap">
            话题标签
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
            热门话题探索
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            发现当下最受关注的高清视频话题
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 max-w-3xl mx-auto">
          {topics.map((topic) => (
            <a
              key={topic.label}
              href="#index"
              className="inline-flex items-center gap-2 px-4 py-2.5 rounded-full bg-background-100 border border-background-200/60 text-foreground-700 hover:bg-primary-50 hover:border-primary-200 hover:text-primary-600 transition-colors text-sm font-medium whitespace-nowrap cursor-pointer"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className={`${topic.icon} text-xs`}></i>
              </span>
              {topic.label}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}